import { generateDxToPlatfMap } from '../routes/Diagnosis/utils/Diagnosis';
import { dmdAlerts } from './platformSettings/dmd';
import { epilepsyAlerts } from './platformSettings/epilepsy';
import { mgravisAlerts } from './platformSettings/mgravis';
import { msAlerts, msFilteredTypes } from './platformSettings/ms';
import { ninmtAlerts } from './platformSettings/ninmt';
import { parkinsonFilteredTypes, parkinsonAlerts } from './platformSettings/parkinson';
import { sleepApneaAlerts, sleepApneaFilteredTypes } from './platformSettings/sleepApnea';
import { smaAlerts } from './platformSettings/sma';

// These documents are filtered from navigation after routes have been loaded
export const filteredDocumentTypes = (
  platform: Platform | undefined,
  docs: IDocumentV2[] | undefined = [],
): string[] => {
  const filterList: { [platform in Platform]?: string[] } = {
    parkinson: parkinsonFilteredTypes(docs),
    ms: msFilteredTypes(docs),
    sleepApnea: sleepApneaFilteredTypes(docs),
  };

  return platform ? (filterList[platform] ?? []) : [];
};

// Get alerts for platforms
export const alerts: { [platform in Platform]?: IAlert[] } = {
  sma: smaAlerts,
  dmd: dmdAlerts,
  ms: msAlerts,
  parkinson: parkinsonAlerts,
  epilepsy: epilepsyAlerts,
  ninmt: ninmtAlerts,
  mgravis: mgravisAlerts,
  sleepApnea: sleepApneaAlerts,
};

const dxToPlatfMap = generateDxToPlatfMap();
export { dxToPlatfMap as diagnosisPlatform };

export const MIRANDA_MED_INTG_SOURCE = 'miranda-medication-integration' as const;

export const RESMED_AVX_INTG_SOURCE = 'resmed-avx-integration' as const;
